import dynamic from "next/dynamic";
import React from "react";

const ContentLayoutFooterNoChartreuse = dynamic(
  () => import("../components/Layout/ContentLayoutFooterNoChartreuse"),
);

function Contact() {
  return (
    <ContentLayoutFooterNoChartreuse title="Contact Us">
      <div className="flex flex-col items-center justify-center overflow-hidden mt-32">
        <h1 className="text-2xl mb-6">Contact Us</h1>
        <div>
          <h5> Please reach out to hi@raraity.com</h5>
        </div>
      </div>
    </ContentLayoutFooterNoChartreuse>
  );
}

export default Contact;

export async function getStaticProps() {
  return {
    props: { page: "Contact" },
  };
}
